import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router';
import { checkDeviceInfo } from '../../hooks/useDeviceType';

let changeType = '';
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  checkDeviceInfo();
  useEffect(() => {
    history.listen((url, type) => {
      changeType = type;
    });
  }, [history]);
  useEffect(() => {
    if (changeType !== 'PUSH') return;
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default ScrollToTop;
